import { WopeeOptions } from '../../domain/configuration/config.interface.js';
import { setWopeeOptionsDefaults } from './configDefaults.js';
import { assertScreenshotValidationConfig } from './configValidation.js';

export abstract class ConfigPort {
  private _config: WopeeOptions;

  abstract _loadConfig(): WopeeOptions;

  loadConfig(): WopeeOptions {
    this._config = setWopeeOptionsDefaults(this._loadConfig());
    // Validated after defaults are merged, so the enabled flag is resolved.
    assertScreenshotValidationConfig(this._config.screenshotValidation);
    return this._config;
  }
}
